/* Alexterrible theme JS — v27: morph hero, marquee, TV, film, accordions, media gallery (photo+video), ajax cart, popup, On tour (Bandsintown), chat overlay */
(function(){
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function(s, c){ return (c||document).querySelector(s); };
  var $$ = function(s, c){ return [].slice.call((c||document).querySelectorAll(s)); };

  /* ---------- header: solid on scroll ---------- */
  window.addEventListener('scroll', function(){
    var on = window.scrollY > 40;
    $$('.topstack').forEach(function(h){ h.classList.toggle('solid', on); });
  }, {passive:true});

  /* ---------- тёмная главная: когда чёрный растворился — шапка снова светлая ---------- */
  function heroDark(){
    var hd = $('.v4.hero-dark');
    if (!hd){ document.body.classList.remove('hero-dark-page','past-hero'); return; }
    document.body.classList.add('hero-dark-page');
    var fade = $('.herofade', hd);
    var r = (fade || hd).getBoundingClientRect();
    var past = fade ? (r.top + r.height * 0.55) < 70 : r.bottom < 70;
    document.body.classList.toggle('past-hero', past);
  }
  heroDark();
  window.addEventListener('scroll', heroDark, {passive:true});
  window.addEventListener('resize', heroDark);
  document.addEventListener('shopify:section:load', heroDark);

  /* ---------- announcement rotator ---------- */
  var arIdx = 0;
  setInterval(function(){
    if (document.hidden) return;
    $$('.annc.a-rot').forEach(function(a){
      var sp = a.querySelectorAll('.ar');
      if (sp.length < 2) return;
      arIdx++;
      [].forEach.call(sp, function(x,k){ x.classList.toggle('on', k === arIdx % sp.length); });
    });
  }, 3600);

  /* ---------- burger ---------- */
  document.addEventListener('click', function(e){
    var ov = $('#menuOv');
    if (!ov) return;
    if (e.target.closest('.burger')) ov.classList.add('open');
    if (e.target.closest('#menuClose')) ov.classList.remove('open');
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){ var ov = $('#menuOv'); if (ov) ov.classList.remove('open'); closeCart(); closePromo(); }
  });

  /* ---------- smooth anchor with header offset ---------- */
  document.addEventListener('click', function(e){
    var go = e.target.closest('[data-goto]');
    if (!go) return;
    var t = document.getElementById(go.getAttribute('data-goto'));
    if (!t) return;
    e.preventDefault();
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 100, behavior:'smooth' });
  });

  /* ---------- morph hero ----------
     v24.1: без дёрганья на телефоне — высота секции фиксируется в px (адресная строка
     Safari больше не двигает прогресс), стили пишутся только при изменении, blur
     квантуется, на телефоне нет drop-shadow (дорогой фильтр на каждый кадр). */
  (function morphInit(){
    var refs = null, lockedW = 0, last = {};
    function grab(){
      var mh = $('#morphhero'); if (!mh) return null;
      var r = { mh: mh, mm: $('#morphmask'), mw1: $('#mw1'), mw2: $('#mw2'), rv: $('#mhreveal'), sc: $('#mhscr'), stk: mh.querySelector('.mh-sticky') };
      if (!r.mm || !r.mw1 || !r.mw2 || !r.rv) return null;
      return r;
    }
    function lock(){
      if (!refs) return;
      var mh = refs.mh;
      if (refs.origH === undefined) refs.origH = mh.style.height;   /* исходная высота (из CSS или inline) */
      mh.style.height = refs.origH;                          /* вернуть её, чтобы измерить честно */
      var h = Math.round(mh.getBoundingClientRect().height);
      if (h > 0) mh.style.height = h + 'px';                 /* и зафиксировать в px */
      refs.vp = refs.stk ? refs.stk.offsetHeight : window.innerHeight;
      refs.total = h - refs.vp;
      lockedW = window.innerWidth;
      last = {};
    }
    function set(el, prop, val){
      var k = prop + (el.id || '');
      if (last[k] === val) return;
      last[k] = val; el.style[prop] = val;
    }
    function tick(){
      requestAnimationFrame(tick);
      if (document.hidden || reduced) return;
      if (!refs || !document.body.contains(refs.mh)){ refs = grab(); if (!refs) return; lock(); }
      if (window.innerWidth !== lockedW) lock();
      var mh = refs.mh, mm = refs.mm, mw1 = refs.mw1, mw2 = refs.mw2, rv = refs.rv, sc = refs.sc;
      var top = mh.getBoundingClientRect().top;
      var p = Math.max(0, Math.min(1, -top / (refs.total || 1)));
      p = Math.round(p * 400) / 400;                          /* шаг 0.25% — глаз не видит, а лишних перерисовок нет */
      var e2 = p < .5 ? 2*p*p : 1 - Math.pow(-2*p + 2, 2)/2;
      var mob = window.innerWidth <= 760;
      set(mm, 'transform', mob
        ? 'translate3d(0,' + (e2*34).toFixed(1) + 'px,0) scale(' + (1 - e2*0.13).toFixed(3) + ')'
        : 'translate3d(-50%,' + (-47 + e2*10).toFixed(2) + '%,0) scale(' + (1 - e2*0.13).toFixed(3) + ')');
      var fade = Math.min(1, p/0.72);
      set(mm, 'opacity', (1 - fade*0.75).toFixed(3));
      var blur = Math.round(e2*14*2)/2, br = (1 - fade*0.45).toFixed(2);
      set(mm, 'filter', (mob ? '' : 'drop-shadow(0 40px 80px rgba(0,0,0,.3)) ') + 'blur(' + blur + 'px) brightness(' + br + ')');
      var sp = parseFloat(mh.getAttribute('data-spread')) || 19;
      var spm = parseFloat(mh.getAttribute('data-spread-mob')) || 7;
      var split = mob ? spm : sp;
      set(mw1, 'transform', 'translate3d(' + (-e2*split).toFixed(2) + 'vw,0,0)');
      set(mw2, 'transform', 'translate3d(' + (e2*split).toFixed(2) + 'vw,0,0)');
      var r2 = Math.max(0, Math.min(1, (p-.5)/.32));
      set(rv, 'opacity', r2.toFixed(3));
      set(rv, 'pointerEvents', r2 > .5 ? 'auto' : 'none');
      set(rv, 'transform', 'translate3d(-50%,' + (-30 - r2*10).toFixed(2) + '%,0)');
      if (sc){ set(sc, 'opacity', Math.max(0, 1 - p/0.22).toFixed(3)); set(sc, 'pointerEvents', p > 0.2 ? 'none' : 'auto'); }
    }
    tick();
    window.addEventListener('orientationchange', function(){ setTimeout(function(){ if (refs) lock(); }, 350); });
    document.addEventListener('shopify:section:load', function(){ refs = null; });
  })();

  /* ---------- lightning promo hero (optional) ---------- */
  function strikeK(){
    var heroK = $('#heroK'), cv = $('#boltK'), flash = $('#flashK');
    if (!heroK || !cv || !flash) return;
    if (cv.width !== heroK.clientWidth || cv.height !== heroK.clientHeight){ cv.width = heroK.clientWidth; cv.height = heroK.clientHeight; }
    var fx = cv.getContext('2d');
    var LGT = document.body.classList.contains('light');
    var x = cv.width*0.5 + (Math.random()<.5?-1:1)*cv.width*(0.09+Math.random()*0.09);
    fx.clearRect(0,0,cv.width,cv.height);
    for (var pass = 0; pass < 2; pass++){
      fx.beginPath();
      var y = 0, px = x;
      fx.moveTo(px, y);
      while (y < cv.height*0.86){
        y += 14 + Math.random()*26;
        px += (Math.random()-0.5)*70;
        fx.lineTo(px, y);
      }
      fx.lineWidth = pass ? 2.4 : 7;
      fx.strokeStyle = pass ? (LGT ? 'rgba(16,16,20,.92)' : 'rgba(255,255,255,.95)') : (LGT ? 'rgba(70,80,130,.4)' : 'rgba(150,170,255,.45)');
      fx.stroke();
    }
    flash.style.transition = 'none'; flash.style.opacity = .4;
    setTimeout(function(){ flash.style.transition = 'opacity .5s ease'; flash.style.opacity = 0; }, 60);
    setTimeout(function(){ fx.clearRect(0,0,cv.width,cv.height); }, 520);
    if (!reduced){ heroK.classList.remove('shakek'); void heroK.offsetWidth; heroK.classList.add('shakek'); }
  }
  document.addEventListener('click', function(e){
    var hk = e.target.closest('#heroK');
    if (!hk || e.target.closest('.topstack, .under, button, a')) return;
    strikeK();
  });
  (function loopK(){
    var heroK = $('#heroK');
    if (heroK && !document.hidden && heroK.getBoundingClientRect().bottom > 0) strikeK();
    setTimeout(loopK, 4200 + Math.random()*1600);
  })();

  /* ---------- handmade film (данные берём из блоков секции) ---------- */
  var fIdx = 0, fHold = 0;
  function filmShow(i){
    $$('.film').forEach(function(f){
      var steps = $$('.fsteps li', f);
      if (!steps.length) return;
      var n = (i + steps.length) % steps.length;
      fIdx = n;
      $$('.fscreen img', f).forEach(function(im,k){ im.classList.toggle('on', k===n); });
      steps.forEach(function(li,k){ li.classList.toggle('on', k===n); });
      var fn = $('.fn', f), ft = $('.ft', f), fl = $('.flead', f);
      var cur = steps[n];
      if (fn) fn.textContent = cur.getAttribute('data-n') || ('0'+(n+1)).slice(-2);
      if (ft) ft.textContent = cur.getAttribute('data-ttl') || '';
      if (fl){ fl.style.opacity = 0; setTimeout(function(){ fl.textContent = cur.getAttribute('data-txt') || ''; fl.style.opacity = 1; }, 260); }
    });
  }
  if ($('.film')){
    setInterval(function(){
      if (document.hidden) return;
      if (fHold > 0){ fHold--; return; }
      filmShow(fIdx+1);
    }, 3400);
    document.addEventListener('click', function(e){
      var st = e.target.closest('.fsteps li[data-f]');
      if (st){ filmShow(+st.getAttribute('data-f')); fHold = 3; }
    });
  }

  /* ---------- TV zap ---------- */
  var tvIdx = 0;
  setInterval(function(){
    if (document.hidden || !$('.tv')) return;
    tvIdx = (tvIdx + 1) % 4;
    $$('.tv').forEach(function(tv){
      var band = tv.closest('[data-tv-labels]');
      var labels = band ? band.getAttribute('data-tv-labels').split('|') : ['On stage','Live','Berserk','The masks'];
      tv.classList.add('zap');
      setTimeout(function(){
        $$('.tvimg', tv).forEach(function(im,k){ im.classList.toggle('on', k===tvIdx); });
        var cap = $('.tvcap', tv);
        if (cap){ $('.ch', cap).textContent = 'CH 0'+(tvIdx+1); $('.tt', cap).textContent = labels[tvIdx] || ''; }
      }, 130);
      setTimeout(function(){ tv.classList.remove('zap'); }, 380);
    });
  }, 3800);

  /* ---------- generic slideshow ---------- */
  setInterval(function(){
    if (document.hidden) return;
    $$('.atslides').forEach(function(sec){
      if (sec.getAttribute('data-hold')) { sec.removeAttribute('data-hold'); return; }
      var speed = parseInt(sec.getAttribute('data-speed'),10) || 5000;
      var now = Date.now();
      var last = parseInt(sec.getAttribute('data-last'),10) || 0;
      if (now - last < speed) return;
      sec.setAttribute('data-last', now);
      var slides = $$('.atslide', sec);
      if (slides.length < 2) return;
      var cur = 0; slides.forEach(function(x,k){ if (x.classList.contains('on')) cur = k; });
      var nxt = (cur+1) % slides.length;
      slides.forEach(function(x,k){ x.classList.toggle('on', k===nxt); });
      $$('.atdots button', sec).forEach(function(d,k){ d.classList.toggle('on', k===nxt); });
    });
  }, 500);
  document.addEventListener('click', function(e){
    var d = e.target.closest('.atdots button');
    if (!d) return;
    var sec = d.closest('.atslides');
    var i = +d.getAttribute('data-slide');
    $$('.atslide', sec).forEach(function(x,k){ x.classList.toggle('on', k===i); });
    $$('.atdots button', sec).forEach(function(x,k){ x.classList.toggle('on', k===i); });
    sec.setAttribute('data-last', Date.now());
  });

  /* ---------- accordions (exclusive per group, highlight open) ---------- */
  document.addEventListener('click', function(e){
    var aq = e.target.closest('.acc .aq');
    if (!aq) return;
    var acc = aq.parentElement;
    var group = acc.closest('.accs');
    var was = acc.classList.contains('open');
    if (group && !group.classList.contains('single')){
      $$('.acc', group).forEach(function(c){ c.classList.remove('open'); c.querySelector('.aa').style.maxHeight = ''; });
    } else if (group){
      $$('.acc', document).forEach(function(c){
        if (c !== acc && c.closest('.pinfo')){ c.classList.remove('open'); var aa = c.querySelector('.aa'); if (aa) aa.style.maxHeight = ''; }
      });
    }
    if (!was){ acc.classList.add('open'); var aa2 = acc.querySelector('.aa'); if (aa2) aa2.style.maxHeight = '1200px'; }
    else { acc.classList.remove('open'); var aa3 = acc.querySelector('.aa'); if (aa3) aa3.style.maxHeight = ''; }
  });

  /* ---------- галерея товара (v27): слайды с фото и видео, одна рамка ----------
     Разметка: .prodwrap > .thumbcol > button.gth[data-i] ; .bigimg > .gframe > .gslide(.on)
     Видео в активном слайде играет само без звука; кнопка [data-gsnd] включает звук. */
  function galSlides(w){ return $$('.gslide', w); }
  function galCur(w){
    var s = galSlides(w), c = 0;
    s.forEach(function(x,k){ if (x.classList.contains('on')) c = k; });
    return c;
  }
  function galPlay(slide, on){
    var v = slide.querySelector('video');
    if (v){
      if (on){ var p = v.play(); if (p && p.catch) p.catch(function(){}); }
      else { try { v.pause(); } catch(e){} }
    }
    var f = slide.querySelector('iframe.gext');          /* YouTube: ставим на паузу, снимая src */
    if (f){
      if (on){ if (!f.getAttribute('src') && f.dataset.src) f.setAttribute('src', f.dataset.src); }
      else if (f.getAttribute('src')){ f.dataset.src = f.getAttribute('src'); f.removeAttribute('src'); }
    }
  }
  function galGo(w, i){
    var s = galSlides(w);
    if (!s.length) return;
    i = (i + s.length) % s.length;
    s.forEach(function(x,k){ var on = k === i; x.classList.toggle('on', on); galPlay(x, on); });
    var th = $$('.gth', w);
    th.forEach(function(t,k){
      t.classList.toggle('on', k === i);
      var im = t.querySelector('img'); if (im) im.classList.toggle('on', k === i);
    });
    var c = $('.gcount .gc', w); if (c) c.textContent = i + 1;
    if (th[i]){ try { th[i].scrollIntoView({block:'nearest', inline:'center', behavior:'smooth'}); } catch(err){} }
  }
  window.atGalleryGo = galGo;
  document.addEventListener('click', function(e){
    if (!e.target.closest) return;
    var snd = e.target.closest('[data-gsnd]');
    if (snd){
      var v = snd.parentNode.querySelector('video'); if (!v) return;
      v.muted = !v.muted;
      snd.classList.toggle('on', !v.muted);
      var sp = snd.querySelector('span'); if (sp) sp.textContent = v.muted ? '♪' : '♫';
      if (!v.muted){ var pl = v.play(); if (pl && pl.catch) pl.catch(function(){}); }
      return;
    }
    var t = e.target.closest('.gth');
    var g = e.target.closest('.gnav');
    if (!t && !g) return;
    var w = (t || g).closest('.prodwrap');
    if (!w) return;
    galGo(w, t ? parseInt(t.getAttribute('data-i'), 10) || 0 : galCur(w) + (g.classList.contains('gnext') ? 1 : -1));
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if (document.activeElement && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) return;
    var w = $('.prodwrap'); if (!w || !galSlides(w).length) return;
    galGo(w, galCur(w) + (e.key === 'ArrowRight' ? 1 : -1));
  });
  /* свайп по главному фото на телефоне */
  (function galSwipe(){
    var big = $('.bigimg');
    if (!big) return;
    var w = big.closest('.prodwrap'), x0 = null, y0 = null;
    big.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, {passive:true});
    big.addEventListener('touchend', function(e){
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) galGo(w, galCur(w) + (dx < 0 ? 1 : -1));
      x0 = null; y0 = null;
    }, {passive:true});
  })();
  /* видео в первом слайде — запустить сразу; и не крутить видео, пока страница скрыта */
  $$('.prodwrap').forEach(function(w){
    var s = galSlides(w); if (!s.length) return;
    galPlay(s[galCur(w)], true);
    s.forEach(function(x,k){ if (k !== galCur(w)) galPlay(x, false); });
  });
  document.addEventListener('visibilitychange', function(){
    $$('.prodwrap').forEach(function(w){ var s = galSlides(w); if (s.length) galPlay(s[galCur(w)], !document.hidden); });
  });

  /* ---------- плашка «в корзину» внизу на телефоне ---------- */
  (function stickyBuy(){
    if (!document.querySelector('[data-stickybuy]')) return;
    var form = document.getElementById('atForm');
    if (!form) return;
    var real = form.querySelector('.atcbig');
    if (!real) return;
    if (document.querySelector('.buybar')) return;

    var title = $('.pinfo h1'), prc = $('.pinfo .prc');
    var bar = document.createElement('div');
    bar.className = 'buybar';
    var l = document.createElement('div'); l.className = 'bbl';
    var b1 = document.createElement('b'); b1.textContent = title ? title.textContent.trim() : '';
    var s1 = document.createElement('span'); if (prc) s1.innerHTML = prc.innerHTML;
    l.appendChild(b1); l.appendChild(s1);
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'bbbtn';
    btn.textContent = (real.textContent || 'Add to cart').trim();
    if (real.disabled) btn.disabled = true;
    bar.appendChild(l); bar.appendChild(btn);
    document.body.appendChild(bar);
    btn.addEventListener('click', function(){ real.click(); });

    if (!('IntersectionObserver' in window)) { bar.classList.add('on'); return; }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ bar.classList.toggle('on', !e.isIntersecting); });
    }, { rootMargin: '-10px 0px -10px 0px', threshold: 0 });
    io.observe(real);
  })();

  /* ---------- фото товара на весь экран ---------- */
  (function zoomInit(){
    var ov = null;
    function build(){
      if (ov) return ov;
      ov = document.createElement('div');
      ov.id = 'zoomOv'; ov.hidden = true;
      ov.innerHTML = '<button class="zclose" type="button" aria-label="Close">✕</button><img alt="">';
      document.body.appendChild(ov);
      return ov;
    }
    function openZ(src){
      build();
      ov.querySelector('img').src = src;
      ov.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeZ(){
      if (!ov) return;
      ov.hidden = true;
      document.body.style.overflow = '';
    }
    document.addEventListener('click', function(e){
      if (!e.target.closest) return;
      var big = e.target.closest('.bigimg .gslide img, .bigimg > img');
      if (big){ openZ(big.currentSrc || big.src); return; }
      if (e.target.closest('#zoomOv')) closeZ();
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeZ(); });
  })();

  /* ---------- Shopify product recommendations ---------- */
  (function loadReco(){
    var box = $('[data-reco]');
    if (!box) return;
    var url = box.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function(r){ return r.text(); }).then(function(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-reco]');
      if (fresh) box.innerHTML = fresh.innerHTML;
    }).catch(function(){});
  })();

  /* ---------- product qty ---------- */
  document.addEventListener('click', function(e){
    var q = e.target.closest('.qty [data-q]');
    if (!q) return;
    var b = $('#ppq'), inp = $('#qtyInput');
    var v = Math.max(1, (parseInt(b.textContent,10)||1) + parseInt(q.getAttribute('data-q'),10));
    b.textContent = v; if (inp) inp.value = v;
  });
  var buy = $('#ppBuy');
  if (buy) buy.addEventListener('click', function(){
    var f = $('#atForm');
    var fd = new FormData(f);
    fetch('/cart/add.js', {method:'POST', body:fd}).then(function(){ window.location.href = '/checkout'; });
  });

  /* ---------- одежда: выбор варианта (размер/цвет) ---------- */
  (function variantPicker(){
    var box = $('[data-vpick]'); if (!box) return;
    var form = $('#atForm'); var idInp = form ? form.querySelector('input[name="id"]') : null;
    var data = box.querySelector('[data-variants]'); if (!data) return;
    var variants; try { variants = JSON.parse(data.textContent); } catch(e){ return; }
    var opts = $$('.vopt', box);
    function selected(){ return opts.map(function(o){ var on = o.querySelector('.vv.on'); return on ? on.getAttribute('data-val') : null; }); }
    function find(sel){
      for (var i = 0; i < variants.length; i++){
        var v = variants[i], ok = true;
        for (var k = 0; k < sel.length; k++){ if (sel[k] !== null && v.options[k] !== sel[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function fmt(cents){ try { return money(cents); } catch(e){ return (cents/100).toFixed(2); } }
    function apply(initial){
      var sel = selected(), v = find(sel);
      /* недоступные значения — пунктиром */
      opts.forEach(function(o, oi){
        $$('.vv', o).forEach(function(b){
          var test = sel.slice(); test[oi] = b.getAttribute('data-val');
          var any = variants.some(function(x){ for (var k = 0; k < test.length; k++){ if (test[k] !== null && x.options[k] !== test[k]) return false; } return x.available; });
          b.classList.toggle('na', !any);
        });
        var lab = o.querySelector('.vsel'); var on = o.querySelector('.vv.on');
        if (lab && on) lab.textContent = '— ' + on.getAttribute('data-val');
      });
      var btn = form ? form.querySelector('.atcbig') : null;
      var buyb = $('#ppBuy'); var bar = $('.buybar');
      if (!v){ if (btn){ btn.disabled = true; btn.textContent = 'Unavailable'; } return; }
      if (idInp) idInp.value = v.id;
      var prc = $('.pinfo .prc');
      if (prc && !initial){
        prc.innerHTML = fmt(v.price) + (v.compare_at_price && v.compare_at_price > v.price ? ' <s>' + fmt(v.compare_at_price) + '</s>' : '');
        if (bar){ var sp = bar.querySelector('.bbl span'); if (sp) sp.innerHTML = prc.innerHTML; }
      }
      if (btn){ btn.disabled = !v.available; btn.textContent = v.available ? (btn.getAttribute('data-label') || btn.textContent) : 'Sold out'; }
      if (buyb) buyb.disabled = !v.available;
      if (bar){ var bb = bar.querySelector('.bbbtn'); if (bb){ bb.disabled = !v.available; bb.textContent = v.available ? (btn ? btn.textContent : 'Add to cart') : 'Sold out'; } }
      /* фото варианта: переключаем галерею на слайд с этим медиа (v27) */
      if (!initial && v.featured_media && v.featured_media.id){
        var w = $('.prodwrap'), idx = -1;
        if (w){ $$('.gslide', w).forEach(function(s,k){ if (s.getAttribute('data-media-id') === String(v.featured_media.id)) idx = k; }); }
        if (idx >= 0 && window.atGalleryGo) window.atGalleryGo(w, idx);
      }
      try {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        history.replaceState(null, '', u.toString());
      } catch(e){}
    }
    var firstBtn = form ? form.querySelector('.atcbig') : null;
    if (firstBtn && !firstBtn.disabled) firstBtn.setAttribute('data-label', firstBtn.textContent.trim());
    box.addEventListener('click', function(e){
      var b = e.target.closest('.vv'); if (!b) return;
      var o = b.closest('.vopt');
      $$('.vv', o).forEach(function(x){ x.classList.remove('on'); });
      b.classList.add('on');
      apply(false);
    });
    apply(true);
  })();

  /* ---------- таблица размеров ---------- */
  document.addEventListener('click', function(e){
    if (!e.target.closest) return;
    var ov = $('#szOv'); if (!ov) return;
    if (e.target.closest('[data-szopen]')){ ov.hidden = false; document.body.style.overflow = 'hidden'; return; }
    if (e.target.closest('[data-szclose]') || e.target === ov){ ov.hidden = true; document.body.style.overflow = ''; }
  });
  document.addEventListener('keydown', function(e){ var ov = $('#szOv'); if (ov && !ov.hidden && e.key === 'Escape'){ ov.hidden = true; document.body.style.overflow = ''; } });

  /* ---------- AJAX cart drawer ---------- */
  var cartOv = $('#cartOv'), cartDr = $('#cartDr');
  var MF = (cartDr && cartDr.getAttribute('data-mf')) || '${{amount}}';
  function fmtNum(cents, dec, sep, tsep){
    var v = (cents/100).toFixed(dec);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, tsep);
    return parts.length > 1 ? parts[0] + sep + parts[1] : parts[0];
  }
  function money(cents){
    return MF.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, name){
      switch(name){
        case 'amount': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, '.', "'");
        case 'amount_no_decimals_with_space_separator': return fmtNum(cents, 0, '.', ' ');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ',', ' ');
        default: return fmtNum(cents, 2, '.', ',');
      }
    });
  }
  function renderCart(cart){
    $$('.cartcnt').forEach(function(el){ el.textContent = cart.item_count; });
    var n = $('#cartN'); if (n) n.textContent = cart.item_count;
    var s = $('#cartSum'); if (s) s.textContent = money(cart.total_price);
    var box = $('#cartItems');
    if (!box) return;
    if (!cart.items.length){ box.innerHTML = '<div class="cempty">Your cart is empty.<br>Every mask feeds the bears.</div>'; return; }
    box.innerHTML = cart.items.map(function(it){
      return '<div class="citem"><img src="'+(it.image||'')+'&width=128" alt=""><div><div class="n">'+it.product_title.replace('ALEX TERRIBLE MASK ','').replace('ALEX TERRIBLE ','')+'</div><div class="p">'+money(it.final_line_price)+'</div>'+
        '<div class="q"><button data-cq="-1" data-k="'+it.key+'" data-n="'+it.quantity+'">−</button><b>'+it.quantity+'</b><button data-cq="1" data-k="'+it.key+'" data-n="'+it.quantity+'">+</button></div></div>'+
        '<button class="rm" data-rm="'+it.key+'" aria-label="Remove">✕</button></div>';
    }).join('');
  }
  function fetchCart(){ return fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCart); }
  function openCart(added){
    return fetchCart().then(function(){
      var ttl = $('#cartTitle');
      if (ttl) ttl.classList.toggle('added', !!added);
      if (cartOv) cartOv.classList.add('open');
      if (cartDr) cartDr.classList.add('open');
      if (added) setTimeout(function(){ if (ttl) ttl.classList.remove('added'); }, 2600);
    });
  }
  function closeCart(){ if (cartOv) cartOv.classList.remove('open'); if (cartDr) cartDr.classList.remove('open'); }
  if (cartOv) cartOv.addEventListener('click', closeCart);
  if ($('#cartClose')) $('#cartClose').addEventListener('click', closeCart);
  if ($('#cartCont')) $('#cartCont').addEventListener('click', closeCart);
  function changeQty(key, qty){
    fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id:key, quantity:qty})})
      .then(function(r){ return r.json(); }).then(renderCart);
  }
  document.addEventListener('click', function(e){
    var add = e.target.closest('.qadd');
    if (add){
      e.preventDefault();
      fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: +add.getAttribute('data-add'), quantity: 1})})
        .then(function(){ openCart(true); });
      return;
    }
    if (e.target.closest('.cartbtn')){ e.preventDefault(); openCart(); return; }
    var cq = e.target.closest('[data-cq]');
    if (cq){ changeQty(cq.getAttribute('data-k'), Math.max(0, (+cq.getAttribute('data-n')) + (+cq.getAttribute('data-cq')))); return; }
    var rm = e.target.closest('[data-rm]');
    if (rm){ changeQty(rm.getAttribute('data-rm'), 0); return; }
  });
  var atForm = $('#atForm');
  if (atForm) atForm.addEventListener('submit', function(e){
    e.preventDefault();
    fetch('/cart/add.js', {method:'POST', body: new FormData(atForm)}).then(function(){ openCart(true); });
  });

  /* ---------- first-visit popup ---------- */
  function closePromo(){ var pr = $('#promo'); if (pr) pr.classList.remove('open'); try{ sessionStorage.setItem('at_promo','1'); }catch(err){} }
  (function initPromo(){
    var promo = $('#promo');
    if (!promo) { setTimeout(initPromo, 1000); return; }
    var seen = false; try{ seen = sessionStorage.getItem('at_promo') === '1'; }catch(err){}
    var delay = parseInt(promo.getAttribute('data-delay'), 10) || 2500;
    if (!seen) setTimeout(function(){ var pr = $('#promo'); if (pr) pr.classList.add('open'); }, delay);
  })();
  document.addEventListener('click', function(e){
    var pr = e.target.closest('#promo');
    if (!pr) return;
    if (e.target === pr || e.target.closest('.pclose') || e.target.closest('#promoNo')) closePromo();
  });
})();

/* ---------- подразделы в бургер-меню ---------- */
(function(){
  document.addEventListener('click', function(e){
    var t = e.target.closest('.mtoggle');
    if (!t) return;
    var li = t.parentElement;
    var box = li.querySelector('.msub');
    var open = li.classList.contains('open');
    /* одновременно раскрыт только один раздел */
    Array.prototype.forEach.call(document.querySelectorAll('#menuOv li.has-sub.open'), function(x){
      if (x === li) return;
      x.classList.remove('open');
      var b = x.querySelector('.msub'); if (b) b.style.maxHeight = '';
      var tb = x.querySelector('.mtoggle'); if (tb) tb.setAttribute('aria-expanded', 'false');
    });
    if (open){
      li.classList.remove('open');
      if (box) box.style.maxHeight = '';
      t.setAttribute('aria-expanded', 'false');
    } else {
      li.classList.add('open');
      if (box) box.style.maxHeight = box.scrollHeight + 'px';
      t.setAttribute('aria-expanded', 'true');
    }
  });
})();

/* ---------- FAQ: кнопки-разделы ---------- */
(function(){
  var chips = Array.prototype.slice.call(document.querySelectorAll('[data-faqjump]'));
  if (!chips.length) return;
  chips.forEach(function(a){
    a.addEventListener('click', function(){
      chips.forEach(function(x){ x.classList.remove('on'); });
      a.classList.add('on');
    });
  });
  var heads = chips.map(function(a){ return document.querySelector(a.getAttribute('href')); }).filter(Boolean);
  function sync(){
    var y = window.scrollY + 190, cur = 0;
    heads.forEach(function(h,i){ if (h.offsetTop <= y) cur = i; });
    chips.forEach(function(x,i){ x.classList.toggle('on', i === cur); });
  }
  var t = null;
  window.addEventListener('scroll', function(){ if (t) return; t = setTimeout(function(){ t = null; sync(); }, 120); }, {passive:true});
  sync();
})();

/* ---------- меню: подсветка нажатого пункта ---------- */
(function(){
  document.addEventListener('click', function(e){
    var a = e.target.closest('#menuOv ol li a, .mlinks a, .navlink');
    if (!a) return;
    var scope = a.closest('#menuOv') || document;
    Array.prototype.forEach.call(scope.querySelectorAll('#menuOv ol li a, .mlinks a, .navlink'), function(x){ x.classList.remove('tapped'); });
    a.classList.add('tapped', 'on');
  }, true);
})();

/* ============================================================
   v11 — On tour: фон-видео, сторис Instagram (даты концертов — см. v24 внизу)
   ============================================================ */
(function(){
  var $ = function(s, r){ return (r||document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };

  /* ---------- фон-видео по ссылке (YouTube / Vimeo) ---------- */
  function vid(url){
    if (!url) return null;
    var m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
    if (m) return {type:'youtube', id:m[1]};
    m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (m) return {type:'vimeo', id:m[1]};
    if (/^[A-Za-z0-9_-]{8,}$/.test(url.trim())) return {type:'youtube', id:url.trim()};
    return null;
  }
  function bgHost(el){
    var h = el.closest ? el.closest('.tourband, .pvband') : null;
    return h || el.parentNode;
  }
  function extBg(){
    var mob = window.innerWidth <= 760;

    /* mp4: подставляем нужный файл под текущую ширину и переключаем при ресайзе */
    $$('video.tbgvid').forEach(function(v){
      var noMob = v.hasAttribute('data-nomobile');
      var d = v.getAttribute('data-src-d') || '';
      var m = v.getAttribute('data-src-m') || '';
      var want = mob ? (m || d) : (d || m);
      if (mob && noMob) want = '';
      var host = bgHost(v);
      if (!want){
        if (v.dataset.cur){ try{ v.pause(); }catch(e0){} v.removeAttribute('src'); try{ v.load(); }catch(e1){} v.dataset.cur = ''; }
        v.hidden = true;
        if (host && host.classList) host.classList.remove('vplay');
        return;
      }
      v.hidden = false;
      if (v.dataset.cur === want) return;
      v.dataset.cur = want;
      if (!v.dataset.hooked){
        v.dataset.hooked = '1';
        v.addEventListener('playing', function(){ var h = bgHost(v); if (h && h.classList) h.classList.add('vplay'); });
        v.addEventListener('error', function(){ var h = bgHost(v); if (h && h.classList) h.classList.remove('vplay'); });
      }
      v.src = want;
      try { v.load(); } catch(e2){}
      var pl = v.play(); if (pl && pl.catch) pl.catch(function(){});
    });

    $$('.tbgext').forEach(function(box){
      var noMob = box.hasAttribute('data-nomobile');
      var host = bgHost(box);
      if (mob && noMob){
        if (box.dataset.cur){ box.innerHTML = ''; box.dataset.cur = ''; }
        box.hidden = true;
        if (host && host.classList) host.classList.remove('vplay');
        return;
      }
      box.hidden = false;
      var v = vid(box.getAttribute('data-vsrc') || '');
      if (!v) return;
      var key = v.type + ':' + v.id;
      if (box.dataset.cur === key) return;
      box.dataset.cur = key;
      box.innerHTML = '';
      var src = v.type === 'vimeo'
        ? 'https://player.vimeo.com/video/'+v.id+'?background=1&autoplay=1&loop=1&muted=1&autopause=0'
        : 'https://www.youtube.com/embed/'+v.id+'?autoplay=1&mute=1&loop=1&playlist='+v.id+'&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1&disablekb=1';
      var f = document.createElement('iframe');
      f.src = src; f.title = 'Background video'; f.setAttribute('frameborder','0'); f.tabIndex = -1;
      f.allow = 'autoplay; encrypted-media; picture-in-picture';
      box.appendChild(f);
      if (host && host.classList) host.classList.add('vplay');
    });
  }
  extBg();
  document.addEventListener('shopify:section:load', extBg);
  var bgTmr;
  window.addEventListener('resize', function(){ clearTimeout(bgTmr); bgTmr = setTimeout(extBg, 200); });
  window.addEventListener('orientationchange', function(){ setTimeout(extBg, 300); });

  /* ---------- кнопка звука у видео-полосы ---------- */
  function pvSound(){
    $$('[data-pvsound]').forEach(function(b){
      if (b.dataset.done) return;
      b.dataset.done = '1';
      b.addEventListener('click', function(){
        var host = b.closest ? b.closest('.pvband') : null;
        var v = host ? host.querySelector('video.pvvid') : null;
        if (!v) return;
        v.muted = !v.muted;
        b.classList.toggle('on', !v.muted);
        b.querySelector('span').textContent = v.muted ? '♪' : '♫';
        if (!v.muted){ var pl = v.play(); if (pl && pl.catch) pl.catch(function(){}); }
      });
    });
  }
  pvSound();
  document.addEventListener('shopify:section:load', pvSound);

  /* ---------- сторис ---------- */
  var sIdx = 0;
  function storyOpen(i){
    var ov = $('#storyov'); if (!ov) return;
    var n = $$('.ss', ov).length; if (!n) return;
    sIdx = (i + n) % n;
    ov.hidden = false;
    document.body.style.overflow = 'hidden';
    $$('.ss', ov).forEach(function(f,k){ f.classList.toggle('on', k===sIdx); });
    $$('.storybars i', ov).forEach(function(b,k){ b.classList.toggle('on', k<=sIdx); });
  }
  function storyClose(){
    var ov = $('#storyov'); if (!ov) return;
    ov.hidden = true; document.body.style.overflow = '';
  }
  document.addEventListener('click', function(e){
    var hl = e.target.closest('.hl[data-story]');
    if (hl){ storyOpen(+hl.getAttribute('data-story')); return; }
    if (e.target.closest('.storyx')){ storyClose(); return; }
    var nv = e.target.closest('.storynav');
    if (nv){ storyOpen(sIdx + (nv.classList.contains('snext') ? 1 : -1)); return; }
    if (e.target.id === 'storyov'){ storyClose(); }
  });
  document.addEventListener('keydown', function(e){
    var ov = $('#storyov'); if (!ov || ov.hidden) return;
    if (e.key === 'Escape') storyClose();
    if (e.key === 'ArrowRight') storyOpen(sIdx+1);
    if (e.key === 'ArrowLeft') storyOpen(sIdx-1);
  });

})();
/* ============================================================
   v23.2 — «Track order» открывает AI-чат в окне поверх сайта.
   ============================================================ */
(function chatOverlay(){
  var FALLBACK = 'https://app.zipchat.ai/iframe/?widget_token=a1mvavUEpqxGLlyqlvhs';
  var ov = null;
  function build(url){
    if (ov) return ov;
    ov = document.createElement('div');
    ov.id = 'chatOv'; ov.hidden = true;
    ov.innerHTML =
      '<div class="chatbox">' +
        '<div class="chathead"><span>Track your order</span><button type="button" class="chatclose" aria-label="Close">✕</button></div>' +
        '<iframe title="Chat" allow="microphone; clipboard-write" loading="lazy"></iframe>' +
      '</div>';
    document.body.appendChild(ov);
    ov.addEventListener('click', function(e){ if (e.target === ov || e.target.closest('.chatclose')) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !ov.hidden) close(); });
    return ov;
  }
  function open(url){
    build();
    var f = ov.querySelector('iframe');
    if (f.getAttribute('src') !== url) f.setAttribute('src', url);
    ov.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function close(){ if (!ov) return; ov.hidden = true; document.body.style.overflow = ''; }
  document.addEventListener('click', function(e){
    if (!e.target.closest) return;
    var a = e.target.closest('[data-openchat]'); if (!a) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var m = document.getElementById('menuOv'); if (m && m.classList.contains('open')) m.classList.remove('open');
    open(a.getAttribute('data-chat-url') || a.getAttribute('href') || FALLBACK);
  }, true);
})();

/* ============================================================
   v24 — On tour: даты концертов.
   Источник — Bandsintown (публичный API, ключ не нужен). Блоки
   «Концерт (вручную)» — запасной список, если API недоступен.
   Прошедшие даты отсеиваются; лимиты «показать сразу» и «всего»
   применяются уже после отсева, поэтому старые даты квоту не едят.
   ============================================================ */
(function tourShows(){
  var MON3 = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  var MONTHS = {jan:0,feb:1,mar:2,apr:3,may:4,jun:5,jul:6,aug:7,sep:8,sept:8,oct:9,nov:10,dec:11};
  function today(){ var t = new Date(); t.setHours(0,0,0,0); return t; }
  function parseManual(txt){                       /* «2 OCT», «OCT 12», «12 oct 2026» */
    txt = (txt || '').trim();
    var m = /^(\d{1,2})\s*([A-Za-z]{3,4})\.?,?\s*(\d{4})?$/.exec(txt), d, mo, y;
    if (m){ d = +m[1]; mo = MONTHS[m[2].toLowerCase()]; y = m[3] ? +m[3] : null; }
    else { m = /^([A-Za-z]{3,4})\.?\s*(\d{1,2}),?\s*(\d{4})?$/.exec(txt); if (!m) return null; d = +m[2]; mo = MONTHS[m[1].toLowerCase()]; y = m[3] ? +m[3] : null; }
    if (!d || mo === undefined) return null;
    var now = today();
    if (y) return new Date(y, mo, d);
    var dt = new Date(now.getFullYear(), mo, d);
    if (dt < now - 45*86400000) dt = new Date(now.getFullYear() + 1, mo, d);   /* «12 JAN» в ноябре — это следующий год */
    return dt;
  }
  function parseISO(s){                            /* «2026-10-02T19:00:00» — без сдвига часовых поясов */
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s || ''); if (!m) return null;
    return new Date(+m[1], +m[2]-1, +m[3]);
  }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function place(v){
    if (!v) return '';
    var c = v.city || '', r = v.region || '', k = v.country || '';
    if (/United States|Canada/i.test(k) && r) return c + ', ' + r;
    return c + (k ? ', ' + k : '');
  }
  function rowHTML(ev, withTicket, word){
    var d = parseISO(ev.datetime);
    var link = (ev.offers && ev.offers[0] && ev.offers[0].url) || ev.url || '';
    return '<div class="showrow">' +
      '<span class="sd">' + (d ? d.getDate() + ' ' + MON3[d.getMonth()] : '') + '</span>' +
      '<span class="sv">' + esc(ev.venue && ev.venue.name) + '</span>' +
      '<span class="sc">' + esc(place(ev.venue)) + '</span>' +
      (withTicket && link ? '<a href="' + esc(link) + '" target="_blank" rel="noopener">' + esc(word) + '</a>' : '') +
      '</div>';
  }
  function cleanManual(list){
    var now = today();
    Array.prototype.forEach.call(list.querySelectorAll('.showrow'), function(r){
      var sd = r.querySelector('.sd');
      var dt = parseManual(sd ? sd.textContent : '');
      if (dt && dt < now) r.parentNode.removeChild(r);
    });
  }
  function applyLimit(sec, list, more){
    var first = parseInt(sec.getAttribute('data-bit-first'), 10) || 8;
    var total = parseInt(sec.getAttribute('data-bit-total'), 10) || 0;
    var open = sec.getAttribute('data-bit-open') === '1';
    var rows = Array.prototype.slice.call(list.querySelectorAll('.showrow'));
    if (total > 0 && rows.length > total){ rows.slice(total).forEach(function(r){ r.parentNode.removeChild(r); }); rows = rows.slice(0, total); }
    var empty = list.querySelector('.showsempty');
    if (!rows.length){
      if (!empty){ empty = document.createElement('div'); empty.className = 'showsempty'; empty.textContent = 'No shows announced yet — check back soon.'; list.appendChild(empty); }
      if (more) more.hidden = true;
      return;
    }
    if (empty) empty.parentNode.removeChild(empty);
    if (open || rows.length <= first){
      rows.forEach(function(r){ r.hidden = false; });
      if (more) more.hidden = true;
      return;
    }
    rows.forEach(function(r, i){ r.hidden = i >= first; });
    if (more){
      more.hidden = false;
      more.onclick = function(){ rows.forEach(function(r){ r.hidden = false; }); more.hidden = true; };
    }
  }
  function init(sec){
    if (sec.dataset.showsInit) return;
    sec.dataset.showsInit = '1';
    var list = sec.querySelector('[data-showlist]'); if (!list) return;
    var more = sec.querySelector('[data-showmore]');
    cleanManual(list);
    applyLimit(sec, list, more);
    var source = sec.getAttribute('data-bit-source') || 'widget';
    if (source === 'manual' || !window.fetch) return;
    var artist = sec.getAttribute('data-bit-artist') || 'Slaughter To Prevail';
    var app = sec.getAttribute('data-bit-app') || ('js_' + (location.hostname || 'alexterrible.com'));
    var url = 'https://rest.bandsintown.com/artists/' + encodeURIComponent(artist) + '/events?date=upcoming&app_id=' + encodeURIComponent(app);
    fetch(url).then(function(r){ return r.ok ? r.json() : Promise.reject(r.status); }).then(function(ev){
      if (!Array.isArray(ev)) return;
      var now = today();
      ev = ev.filter(function(x){ var d = parseISO(x.datetime); return d && d >= now; });
      if (!ev.length) return;                                        /* ничего не вернулось — остаётся ручной список */
      var withTicket = list.getAttribute('data-tickets') === '1';
      var word = list.getAttribute('data-ticket-word') || 'Tickets ↗';
      list.innerHTML = ev.map(function(x){ return rowHTML(x, withTicket, word); }).join('');
      applyLimit(sec, list, more);
    }).catch(function(){});
  }
  function all(){ Array.prototype.forEach.call(document.querySelectorAll('.tourband'), init); }
  all();
  document.addEventListener('shopify:section:load', function(){ setTimeout(all, 50); });
})();
/* ============================================================
   v26 — Junip: страховка на случай, если классы у них другие.
   Прячет по содержимому: подпись «Reviewed on …», стрелки голосования,
   «Would recommend». Вставить В КОНЕЦ assets/alexterrible.js.
   ============================================================ */
(function junipClean(){
  var RE_TXT = /^(reviewed on|powered by|would recommend|recommends? this product)/i;
  var RE_ARIA = /(upvote|downvote|vote|helpful|thumbs)/i;
  function hide(el){ if (el && !el.hasAttribute('data-junip-hidden')) el.setAttribute('data-junip-hidden', '1'); }
  function clean(root){
    root = root || document;
    var all = root.querySelectorAll('[class*="junip"] *, [id*="junip"] *');
    for (var i = 0; i < all.length; i++){
      var el = all[i];
      if (el.children.length > 3) continue;                       /* только мелкие узлы, не контейнеры */
      var t = (el.textContent || '').trim();
      if (t.length < 40 && RE_TXT.test(t)){
        hide(el.closest('[class*="footer"], [class*="powered"], [class*="branding"], [class*="recommend"]') || el);
        continue;
      }
      if (el.tagName === 'BUTTON' || el.getAttribute('role') === 'button'){
        var a = (el.getAttribute('aria-label') || el.getAttribute('title') || '') + ' ' + (el.className || '');
        if (RE_ARIA.test(a)) hide(el.closest('[class*="vote"], [class*="helpful"]') || el);
      }
    }
  }
  clean();
  setTimeout(clean, 1500); setTimeout(clean, 4000);
  if ('MutationObserver' in window){
    var t = null;
    new MutationObserver(function(){ clearTimeout(t); t = setTimeout(function(){ clean(); }, 200); })
      .observe(document.body, { childList: true, subtree: true });
  }
})();